module.exports = __webpack_public_path__ + "static/don2-e75b0068cc8216e2d214c24e600f32b7.jpg";